import { Image, Label, Tab } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { VideoIntelligenceData } from './videoIntelligence';

export default function MediaAssetImage() {
  const { activityStore, userStore } = useStore();
  const { selectedActivity: activity } = activityStore;

  const handleVideoIntelligence = (data: any) => {
    activityStore.peopleSelected = data;
    activityStore.peopleData = true;
  };

  var object = false;
  var peoples = false;

  var Vid = VideoIntelligenceData?.forEach((a) =>
    a.info.forEach((b) => {
      if (b.id === activity?.id && a.type !== 'People' && a.image) {
        return (object = true);
      } else if (b.id === activity?.id && a.type === 'People' && a.imageSrc) {
        return (peoples = true);
      }
    }),
  );

  console.log(Vid);

  const people = {
    menuItem: 'People',
    render: () => (
      <Tab.Pane>
        {' '}
        {userStore.user?.email === 'demo.prasadcorp@gmail.com' && (
          <>
            <Image.Group size="mini">
              {/* eslint-disable-next-line */}
              {VideoIntelligenceData.map((a) =>
                a.info.flatMap((b) => {
                  if (b.id === activity?.id && a.type === 'People') {
                    return (
                      <>
                        {' '}
                        <Image
                          style={{
                            width: '50px',
                            height: '50px',
                          }}
                          onClick={() => handleVideoIntelligence(a)}
                          src={a.imageSrc}
                        />
                      </>
                    );
                  } else return [];
                }),
              )}
            </Image.Group>
          </>
        )}
      </Tab.Pane>
    ),
  };

  const objects = {
    menuItem: 'Objects',
    render: () => (
      <Tab.Pane>
        {/* eslint-disable-next-line */}
        {VideoIntelligenceData.map((a) =>
          a.info.flatMap((b) => {
            if (b.id === activity?.id && a.type !== 'People') {
              return (
                <>
                  <Label
                    size="huge"
                    onClick={() => handleVideoIntelligence(a)}
                    style={{
                      margin: '5px 5px',
                      cursor: 'pointer',
                    }}
                  >
                    {a.image}
                  </Label>
                </>
              );
            } else return [];
          }),
        )}
      </Tab.Pane>
    ),
  };

  const paness = [people, objects];
  const dummy: [] = [];

  const pane = object && peoples ? paness : dummy;

  if (!pane?.length) return <></>;
  return (
    <>
      <Tab
        style={{ height: '15vh', width: '62.5vw', marginLeft: '20px' }}
        panes={pane}
      />
    </>
  );
}
